import type { ButtonLinkProps } from "./button-link.type";

import classNames from "classnames";
import { Link } from "react-router";

import PageModalLink from "@/modules/page-modal-link";
import { THEME_KEY, useTheme, THEME_CLASSNAME_PREFIX } from "@/services/theme";

import { BUTTON_LINK_SIZE_MAPPING } from "./button-link.constant";
import { getColorAndVariantValues } from "./button-link.helper";

const ButtonLink = ({
  to,
  type = "default",
  color,
  variant,
  size = "medium",
  shape = "default",
  inModal = false,
  external = false,
  icon,
  children,
  className,
  ...linkProps
}: ButtonLinkProps) => {
  const { hashId } = useTheme();

  const prefix = THEME_CLASSNAME_PREFIX;
  const style = getColorAndVariantValues({ type, color, variant });
  const sizeClassName = BUTTON_LINK_SIZE_MAPPING[size] ?? undefined;
  const shapeClassName = shape !== "default" ? shape : undefined;

  const LinkComponent = inModal ? PageModalLink : external ? "a" : Link;

  return (
    <LinkComponent
      {...linkProps}
      to={!external ? to : ""}
      href={external ? to : undefined}
      target={external ? "_blank" : undefined}
      // Keep `hashId` & `THEME_KEY` classes to make sure theme is applied
      className={classNames(`${prefix}-btn`, hashId, {
        [THEME_KEY]: true,
        [`${prefix}-btn-${shapeClassName}`]: shapeClassName,
        [`${prefix}-btn-${type}`]: type,
        [`${prefix}-btn-color-${style.color}`]: style.color,
        [`${prefix}-btn-variant-${style.variant}`]: style.variant,
        [`${prefix}-btn-${sizeClassName}`]: sizeClassName,
        [`${prefix}-btn-icon-only`]: icon && !children ? true : false,
        [`${className}`]: true,
      })}
    >
      {icon && <span className={`${prefix}-btn-icon`}>{icon}</span>}
      {children && <span>{children}</span>}
    </LinkComponent>
  );
};

export default ButtonLink;
